import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const AddCustomAttributes = () => {
  // Corrected useState hooks - using square brackets []
  const [isLotRequired, setIsLotRequired] = useState(false);
  const [allowNoteForLot, setAllowNoteForLot] = useState(false);
  const [isSerialRequired, setIsSerialRequired] = useState(false);
  const [allowNoteForSerial, setAllowNoteForSerial] = useState(false);
  const [allSpecial] = useState([]);
  const [value, setValue] = useState('');
  const [pricingData] = useState({});

  const handleLotRequiredChange = (e) => {
    setIsLotRequired(e.target.checked);
    if (!e.target.checked) setAllowNoteForLot(false);
  };

  const handleSerialRequiredChange = (e) => {
    setIsSerialRequired(e.target.checked);
    if (!e.target.checked) setAllowNoteForSerial(false);
  };

  const handleValueChange = (e) => {
    setValue(e.target.value);
  };

  // Submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const inputData = {
      valueName: value,
      isLotRequired,
      allowNoteForLot,
      isSerialRequired,
      allowNoteForSerial,
      pricing: pricingData,
      specialPricing: allSpecial,
    };

    try {
      const response = await fetch('https://hms.backend.hiragroupcloud.com/api/addOrthodonticDesign', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(inputData),
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Success:', data);
        // You can add success handling here (reset form, show message, etc.)
      } else {
        console.error('Error submitting form:', response.statusText);
      }
    } catch (error) {
      console.error('Network error:', error);
    }
  };

  const boldStyle = {
    fontWeight: 'bold',
  };

  return (
    <div>
          <div style={{width:"1600px"}}>
            <h2  >Add Custom Attributes</h2>
            
            <h3 style={{color:"#004aad"}}>Details</h3>
            <div style={{borderTop:"2px solid #004aad",backgroundColor:"#f4f4f4"}}>
            <form className="p-4 " onSubmit={handleSubmit} >
              <div className="mb-3">
                <label className="form-label" style={boldStyle}>
                  Value Name *
                </label>
                <input 
                  type="text" 
                  className="form-control"
                  placeholder="Enter Value Name" 
                  onChange={handleValueChange} 
                  value={value} 
                  required
                />
              </div>
              
              <div className="mb-3" style={{ display: 'flex', alignItems: 'center' }}>
                <label className="form-label" style={boldStyle}>
                  Lot #
                </label>
                <div className="form-check" style={{ marginLeft: '12%' }}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={isLotRequired}
                    onChange={handleLotRequiredChange}
                    id="lotRequiredCheckbox"
                  />
                  <label className="form-check-label" htmlFor="lotRequiredCheckbox">
                    Is Required
                  </label>
                </div>
                <div className="form-check" style={{ marginLeft: '10px' }}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={allowNoteForLot}
                    onChange={(e) => setAllowNoteForLot(e.target.checked)}
                    disabled={!isLotRequired}
                    id="lotNoteCheckbox"
                  />
                  <label className="form-check-label" htmlFor="lotNoteCheckbox">
                    Allow Note
                  </label>
                </div>
              </div>
              
              <div className="mb-3" style={{ display: 'flex', alignItems: 'center' }}>
                <label className="form-label" style={boldStyle}>
                  Serial #
                </label>
                <div className="form-check" style={{ marginLeft: '10%' }}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={isSerialRequired}
                    onChange={handleSerialRequiredChange}
                    id="serialRequiredCheckbox"
                  />
                  <label className="form-check-label" htmlFor="serialRequiredCheckbox">
                    Is Required
                  </label>
                </div>
                <div className="form-check" style={{ marginLeft: '10px' }}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={allowNoteForSerial}
                    onChange={(e) => setAllowNoteForSerial(e.target.checked)}
                    disabled={!isSerialRequired}
                    id="serialNoteCheckbox"
                  />
                  <label className="form-check-label" htmlFor="serialNoteCheckbox">
                    Allow Note
                  </label>
                </div>
              </div>
              
              <div style={{ marginTop: '10px', textAlign: 'left' }}>
                <button
                  type="submit"
                  className="btn btn-success"
                  style={{
                    backgroundColor: "#004aad",
                    borderColor: "#004aad"
                  }}
                >
                  Save
                </button>
              </div>
            </form>
            </div>
          </div>
        </div>
     
  );
};

export default AddCustomAttributes;